import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import RecentlyViewedCleanup from "../RecentlyViewedCleanup/RecentlyViewedCleanup";
import PipelineMonitor from "../PipelineMonitor";

const ManageCronJobs = () => {
	const [activeTab, setActiveTab] = useState(0);
	const { t } = useTranslation();

	return (
		<Box width="100%" minHeight="60vh">
			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)}>
					<Tab
						label={t("UI_TEXT.RECENTLY_VIEWED_CLEANUP", {
							defaultValue: "Recently Viewed Cleanup",
						})}
					/>
					<Tab
						label={t("ITEMS_TEXT.PIPELINE_LOGS", {
							defaultValue: "Pipeline Logs",
						})}
					/>
				</Tabs>
			</Box>

			{activeTab === 0 && (
				<Box padding="20px">
					<RecentlyViewedCleanup />
				</Box>
			)}

			{activeTab === 1 && (
				<Box padding="20px">
					<PipelineMonitor />
				</Box>
			)}
		</Box>
	);
};

export default ManageCronJobs;
